import { useTranslation } from 'react-i18next';
import { usePortalPatientData } from './portalContext';
import { Panel, PortalPage, TableCard, formatPortalDate, statusPillClass } from './ui';

export default function ContactsPage() {
  const { t } = useTranslation();
  const { activeContext, profile } = usePortalPatientData();
  const careContacts = profile?.provider
    ? [
        {
          id: profile.provider.id,
          name: profile.provider.name,
          role: profile.provider.title || t('contacts.assignedProvider'),
          phone: t('contacts.phoneViaMessages'),
          email: t('contacts.emailViaMessages'),
        },
      ]
    : [];

  return (
    <PortalPage title={t('contacts.title')} description={t('contacts.description')}>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
        <Panel title={t('contacts.patientProfile')}>
          <div className="space-y-2 text-sm">
            <p>
              <span className="text-slate-500">{t('contacts.name')}</span> {profile?.firstName} {profile?.lastName}
            </p>
            <p>
              <span className="text-slate-500">{t('contacts.mrn')}</span> {profile?.mrn || t('common.na')}
            </p>
            <p>
              <span className="text-slate-500">{t('contacts.dob')}</span> {formatPortalDate(profile?.dob)}
            </p>
            <p>
              <span className="text-slate-500">{t('contacts.email')}</span> {profile?.email || t('common.na')}
            </p>
            <p>
              <span className="text-slate-500">{t('contacts.phone')}</span> {profile?.phone || t('common.na')}
            </p>
            <p>
              <span className="text-slate-500">{t('contacts.status')}</span>{' '}
              <span className={`pill ${statusPillClass(profile?.status || activeContext?.status || 'active')}`}>
                {profile?.status || activeContext?.status || t('contacts.statusActive')}
              </span>
            </p>
            <p>
              <span className="text-slate-500">{t('contacts.provider')}</span> {profile?.provider?.name || activeContext?.provider?.name || t('common.notAssigned')}
            </p>
          </div>
        </Panel>
        <div className="xl:col-span-2">
          <TableCard
            headers={[t('contacts.headerName'), t('contacts.headerRole'), t('contacts.headerPhone'), t('contacts.headerEmail')]}
            rows={careContacts.map((member) => [
              <span key={`${member.id}-name`} className="font-medium text-slate-700">
                {member.name}
              </span>,
              member.role,
              member.phone,
              <span key={`${member.id}-email`} className="text-slate-600">
                {member.email}
              </span>,
            ])}
            emptyMessage={t('contacts.noContacts')}
          />
        </div>
      </div>
    </PortalPage>
  );
}
